// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4850":"52774a7f"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","1226":"c177f142219e7fef","3756":"01e41b3a9ca70d16","4850":"5cd9ae4845339d9d","5391":"32fb77bd5b15fc9f","9839":"12c9392b4199081f"}[chunkId] + ".js";
};